import axios from "axios";
import jsYaml from "js-yaml";
import {datadogLogs} from "@datadog/browser-logs";


export let structure = {
    circles: {},
    concerts: {},
    lms: {},
    regions: {},
    adss: {},
    cmps: {},
    concert: {},
    cmp: {},
    productCode: "",
    langs: {},
    focuses: {},
    audienceTypes: {},
    cities: {},
    places: {},
    demoLms: {},
    skins: {},
    priceModels: {},
    eventTypes: {}
}
export let lgSetup = undefined
export let currentLang = "ru"
let currentSkin = "skin1"
let errorCallBack

export function settCallback(cb) {
    errorCallBack = cb
}



async function getConfTxt() {
    let cfgBaseUrl = ""
    if (typeof window === 'undefined')
        cfgBaseUrl = "https://pay.duoclassico.eu"
    else if (window.location.port > 10000)
        cfgBaseUrl = "http://localhost:3000"
    //console.log("Loading from:" + cfgBaseUrl)
    return await axios(cfgBaseUrl + "/cfg/lgsetup.yaml").then((resp) => {
        return resp.data
    })
}


export async function loadLgAndCmpSetup() {
        let response = await getConfTxt()
        lgSetup = jsYaml.load(response)
        validatePrimitives()
        validateLocations()
        validateLanguagesAndCases()
        denormalizeAndValidateProducts()
        if (typeof window !== 'undefined')
            if (window.location.host.includes("local")) {
                checkResourcesAndExternalLinks()
            }
        validateLg()
        testLrrh()
        testAlekseiBljahhinFIE()
        testCompanyTransformation()
}


function testLrrh() {
    let p = lgSetup.products["LRRH-LG-LEAD"]
    if (p.productCode !== "LRRH-LG-LEAD")
        throw Error("Invalid Code")
    if (p["recordingUrl"] !== "https://duoclassico.eu/lrrh/manual")
        throw Error("Invalid Url " + p["recordingUrl"])
}

function testAlekseiBljahhinFIE() {
    let company = lgSetup.COMPANIES["AlekseiBljahhinFIE"]
    if (!company) 
        throw Error("AlekseiBljahhinFIE not found in COMPANIES")
    
    // Проверка основных полей
    if (company.name !== "ALEKSEI BLJAHHIN FIE")
        throw Error("Invalid name for AlekseiBljahhinFIE")
    if (company.regCode !== "14236389")
        throw Error("Invalid regCode for AlekseiBljahhinFIE")
    if (!company.address.includes("Harjumaa") || !company.address.includes("12616"))
        throw Error("Invalid address for AlekseiBljahhinFIE")
    if (company.vatNumber !== "EE102833777")
        throw Error("Invalid VAT number for AlekseiBljahhinFIE")
    if (company.role !== "Agent")
        throw Error("Invalid role for AlekseiBljahhinFIE")

    // Проверка представителя (representative)
    if (!company.representative)
        throw Error("Missing representative for AlekseiBljahhinFIE")
    if (company.representative.name !== "Aleksei Bljahhin")
        throw Error("Invalid representative name for AlekseiBljahhinFIE")
    if (company.representative.position !== "Owner")
        throw Error("Invalid representative position for AlekseiBljahhinFIE")

    // Проверка контактов (contacts)
    if (!company.contacts)
        throw Error("Missing contacts for AlekseiBljahhinFIE")
    if (!company.contacts.phone.includes("372 5142 537"))
        throw Error("Invalid phone for AlekseiBljahhinFIE")
    if (company.contacts.email !== "aleksei.bljahhin@gmail.com")
        throw Error("Invalid email for AlekseiBljahhinFIE")

    // Проверка банковских данных (bank)
    if (!company.bank)
        throw Error("Missing bank info for AlekseiBljahhinFIE")
    if (company.bank.name !== "SEB")
        throw Error("Invalid bank name for AlekseiBljahhinFIE")
    if (company.bank.country !== "Estonia")
        throw Error("Invalid bank country for AlekseiBljahhinFIE")
    if (company.bank.account !== "EE201010220292097222")
        throw Error("Invalid bank account for AlekseiBljahhinFIE")

    // Проверка формата банковского счета
    if (!company.bank.account.match(/^EE\d{18}$/))
        throw Error("Invalid Estonian IBAN format for AlekseiBljahhinFIE")

    // Проверка формата VAT номера
    if (!company.vatNumber.match(/^EE\d{9}$/))
        throw Error("Invalid Estonian VAT number format for AlekseiBljahhinFIE")
}

function testCompanyTransformation() {
    // Проверяем преобразование в продукте
    let testProduct = lgSetup.products["CATS-BOOK-PDF"]
    if (!testProduct)
        throw Error("Test product CATS-BOOK-PDF not found")
    
    // Проверяем, что myCompany это объект, а не строка
    if (typeof testProduct.myCompany === 'string')
        throw Error("myCompany should be an object, not a string")
    
    // Проверяем, что это правильный объект компании
    if (testProduct.myCompany.name !== "ALEKSEI BLJAHHIN FIE")
        throw Error("Company transformation failed - incorrect company data")
    
    // Проверяем наличие всех необходимых полей в преобразованном объекте
    if (!testProduct.myCompany.regCode || !testProduct.myCompany.address || !testProduct.myCompany.vatNumber)
        throw Error("Company transformation failed - missing required fields")
}

function validateCompanyReference(companyKey, context) {
    if (!lgSetup.COMPANIES[companyKey]) {
        throw Error(`Invalid company reference ${companyKey} in ${context}`)
    }
    return lgSetup.COMPANIES[companyKey]
}

function validateLg() {
    // Проверка компаний в концертах
    Object.keys(lgSetup.concerts).forEach((concertKey) => {
        let concert = lgSetup.concerts[concertKey]
        if (concert.myCompany) {
            validateCompanyReference(concert.myCompany, `concert: ${concertKey}`)
        }
        if (concert.partnerCompany) {
            validateCompanyReference(concert.partnerCompany, `concert: ${concertKey}`)
        }
    })

    validateList(lgSetup, "lms", ["buttonName", "motivation", "desc", "lmUrl"], (objKey, obj) => {
        let urlStr = obj["lmUrl"]
        if (!urlStr.startsWith("https://duoclassico.eu/"))
            throw Error("Empty yor invalid url for lm:" + objKey)
    })
    let adssKeys = {}
    for (var circleKey in lgSetup.circles) {
        let circle = lgSetup.circles[circleKey]
        let event = lgSetup.concerts[circle.concert]
        if (event === undefined)
            throw Error("Invalid concert for circle: " + circleKey)
        for (var lmKey in circle.lms) {
            let lm = lgSetup.lms[lmKey]
            if (lm === undefined)
                throw Error("Invalid lm for circle: " + circleKey + ":" + lmKey)
            let letLmRef = circle.lms[lmKey]
            for (var adsKey in letLmRef) {
                let ad = lgSetup.adss[adsKey]
                if (ad === undefined)
                    throw Error("Invalid ad for circle in lm : " + circleKey + ":" + lmKey)
                if (adssKeys[adsKey] === "OK")
                    throw Error("Duplicated adds in circle:" + circleKey + ":" + adsKey)
                adssKeys[adsKey] = "OK"
            }
        }
        if (circle["sequences"] === undefined)
            throw Error("sequences is mandatory for circle:" + circleKey)
        if (circle["sequences"] === null)
            throw Error("sequences is empty for circle:" + circleKey)


    }
    for (let cmpKey in lgSetup.cmps) {
        let cmp = lgSetup.cmps[cmpKey]
        if (cmp.productCode === undefined)
            throw Error("Empty concert for cmp:" + cmpKey)
        if (cmp["purpose"] === undefined)
            throw Error("Empty purpose for cmp:" + cmpKey)

        for (var circleKey in cmp.circles) {
            if (lgSetup.circles[circleKey] === undefined)
                throw Error("Invalid circle for cmp:" + cmpKey)
        }
        for (var regionKey in cmp.regions) {
            if (lgSetup.regions[regionKey] === undefined)
                throw Error("Invalid geo for cmp:" + cmpKey)
        }

        if (lgSetup.concerts[cmp.concert] === undefined)
            throw Error("Invalid concert forcmp:" + cmpKey)
    }

}


function validatePrimitives() {
    assertKeyNotEmpty("info")
    assertKeyNotEmpty("langs")
    assertKeyNotEmpty("focuses")
    assertKeyNotEmpty("audienceTypes")
    assertKeyNotEmpty("COMPANIES")
}

function validateLocations() {

    assertKeyNotEmpty("countries")
    assertKeyNotEmpty("cities")
    validateList(lgSetup, "cities", ["cityCode", "name", "geoPoint", ["geoPoint", "x"], ["geoPoint", "y"], ["geoPoint", "size"]], (objKey, obj) => {
        validateFkAndAssign(lgSetup, "countries", objKey, obj, "country")
        if (obj["geoPoint"].x === 0)
            throw Error("Missed x for: " + objKey)
        if (obj["geoPoint"].y === 0)
            throw Error("Missed y for: " + objKey)

    })
    assertKeyNotEmpty("regions")
    Object.keys(lgSetup.regions).forEach((regionKey) => {
        let region = lgSetup.regions[regionKey]
        Object.keys(region.cities).forEach((cityKey) => {
            if (lgSetup.cities[cityKey] === undefined)
                throw Error("Invalid city: " + cityKey + " for " + regionKey)
        })
    })
    validateList(lgSetup, "places", ["name", "geoPoint", "address", ["geoPoint", "x"], ["geoPoint", "y"], ["geoPoint", "size"]], (objKey, obj) => {
        validateFkAndAssign(lgSetup, "cities", objKey, obj, "city")
    })

}

function validateLanguagesAndCases() {
    let lng = currentLang
    currentLang = "ru"
    assertKeyEqual("Таллинн", "cities", "TALLINN", "name")
    assertKeyEqual("Таллинне", "cities", "TALLINN", "name#where")
    assertKeyEqual("Баден-Баден", "cities", "BADEN-BADEN", "name")
    assertKeyEqual("Баден-Бадене", "cities", "BADEN-BADEN", "name#where")
    setCurrentLang("et")
    assertKeyEqual("Tallinn", "cities", "TALLINN", "name")
    currentLang = lng
    let skin = currentSkin
    currentSkin = "skin1"
    assertKeyEqual("AAA", "tests", "prop1")
    assertKeyEqual("BBB", "tests", "prop2")
    setCurrentSkin("skin2")
    assertKeyEqual("CCC", "tests", "prop2")
    setCurrentSkin("skin9")
    currentSkin = skin

}

function denormalizeAndValidateProducts() {
    lgSetup["products"] = {}
    lgSetup["events"] = {}
    Object.keys(lgSetup.concerts).forEach((concertKey) => {
        let concert = lgSetup.concerts[concertKey]
        if (concert.demolms !== undefined)
            Object.keys(concert.demolms).forEach((lmsKey) => {
                if (lgSetup.lms[lmsKey] === undefined)
                    throw Error("Invalid lm: " + lmsKey + " for " + concertKey)
            })
        if (concert === null) throw Error("Empty concert: " + concertKey)
        if (concert.events === undefined || concert.events === null) throw Error("Missed field events for concert: " + concertKey)
        if (concert.name === undefined)
            throw Error("Empty concert name: " + concertKey)

        Object.keys(concert.events).forEach((eventKey) => {
            let event = concert.events[eventKey]
            if (event === null) throw Error("Empty event: " + concertKey + "-" + eventKey)
            if (event.products === undefined || event.products === null) throw Error("Missed field products for event: " + concertKey + "-" + eventKey)
            Object.keys(event.products).filter((eventKey) => eventKey !== "NONE").forEach((productKey) => {
                let product = event.products[productKey]
                if (product === null || product === undefined) throw Error("Empty product: " + concertKey + "-" + eventKey + "-" + productKey)
                let productCode = concertKey + "-" + eventKey + "-" + productKey
                let eventCode = concertKey + "-" + eventKey
                let productObj = {}
                let eventObj = {}

                calculateField("myCompany", true)
                calculateField("partnerCompany", false)
                calculateField("projectCode", true)
                
                calculateField("place", true)
                calculateField("autoDiscount", false)
                if (productObj.autoDiscount !== undefined) {
                    if (productObj.autoDiscount.autoDiscount_stepSizeDays < 1) {
                        throw Error("Invalid autoDiscount_stepSizeDays, must be >= 1")
                    }
                }
                calculateField("timezone", true)
                calculateField("time", true)
                calculateField("desc", true)
                calculateField("eventStatus", false)
                calculateField("specialProposalConfig", false)
                calculateField("tenant", false)
                calculateField("tenantEdit", false)
                calculateField("tenantEmail", false)
                calculateField("specialProposal", false)
                calculateField("mailTemplate", false)
                calculateField("cashPayments", false)
                calculateField("date", true)
                calculateField("facebookPost", false)
                calculateField("couponConfig", false)
                calculateField("currency", false)
                calculateField("seatsType", false)
                calculateField("productData", false)
                calculateField("sectors", false)
                calculateField("packageData", false)
                calculateField("ticketBalance", false)
                calculateField("packages", false)
                calculateField("dateStr", false)
                calculateField("timeStr", false)
                calculateField("fullPrice", true)
                calculateField("reducedPrice", false)
                calculateField("region", false)
                if (productObj.region !== undefined)
                    validateFk(lgSetup, "regions", productObj.region, productObj, "region")
                calculateField("name", true)
                calculateField("path", true)
                calculateField("priceInUrlAllowed", false)

                calculateField("type", true)
                validateFk(lgSetup, "eventTypes", productObj.type, productObj, "type")

                calculateField("homepageUrl", true)
                calculateField("sector", false)
                calculateField("shortPageUrl", true)
                calculateField("priceModel", true)
                validateFk(lgSetup, "priceModels", productObj.priceModels, productObj, "priceModel")

                if (productObj["priceModel"] === "FLEX")
                    calculateField("flexParams", true)

                if (productObj.priceModel === "FLEX") {
                    calculateField("priceMessage", true)
                    calculateField("priceHeaderMessage", true)
                } else {
                    calculateField("priceMessage", false)
                    calculateField("priceHeaderMessage", false)
                }


                calculateField("ticketResource", true)
                calculateField("miniposterResource", true)
                calculateField("hallplanResource", false)
                if (productObj["type"] === "RECORDING" || productObj["type"] === "SUBSCRIPTION" || productObj["type"] === "PDF") {
                    calculateField("recordingUrl", true)
                    productObj.place = "ANY"
                    productObj.timezone = "ANY"
                    productObj.time = "ANY"
                    productObj.date = "ANY"
                }
                if (productObj["type"] === "DONATION") {
                    productObj.place = "ANY"
                    productObj.timezone = "ANY"
                    productObj.time = "ANY"
                    productObj.date = "ANY"
                }
                if (productObj["type"] === "ONLINE") {
                    calculateField("recordingUrl", true)
                    productObj.place = "ANY"
                }
                if (productObj["currency"] === undefined) {
                    productObj["currency"] = "€"
                }
                if (productObj["dateStr"] === undefined)
                    productObj["dateStr"] = productObj["date"]
                if (productObj["timeStr"] === undefined)
                    productObj["timeStr"] = productObj["time"]


                productObj.productCode = productCode
                lgSetup.products[productCode] = productObj
                lgSetup.events[eventCode] = eventObj
                validateFkAndAssign(lgSetup, "places", productObj.place, productObj, "place")
                if (productObj.place !== undefined)
                    productObj.place.nameResolved = getImpl(productObj.place, ["name"])
                if (productObj.myCompany)
                    validateFkAndAssign(lgSetup, "COMPANIES", productObj.myCompany, productObj, "myCompany")
                if (productObj.partnerCompany)
                    validateFkAndAssign(lgSetup, "COMPANIES", productObj.partnerCompany, productObj, "partnerCompany")

                function calculateField(key, mandatory) {
                    calculateFieldPr(key, mandatory)
                    calculateFieldEv(key, mandatory)
                }

                function calculateFieldPr(key, mandatory) {

                    let res = getImpl(product, [key])
                    if (res === undefined)
                        res = getImpl(event, [key])
                    if (res === undefined)
                        res = getImpl(concert, [key])
                    if (res === undefined && mandatory)
                        throw Error("Missed calculated filed: " + key + " for " + productCode)
                    productObj[key] = res
                }

                function calculateFieldEv(key, optional) {

                    let res = getImpl(event, [key])
                    if (res === undefined)
                        res = getImpl(concert, [key])
                    if (res !== undefined)
                        eventObj[key] = res
                }

            })
        })
    })


    assertKeyNotEmpty("products")
}

export function calcResource(path, filename) {
    if (path !== undefined)
        return process.env.PUBLIC_URL + "/cfg/" + path + "/" + filename
    else
        return process.env.PUBLIC_URL + "/cfg/" + filename

}


function checkResourcesAndExternalLinks(b) {
    scanNode(0, lgSetup, false, undefined)

    function scanNode(cb, parent, isResource, path, isUrl) {
        cb = cb + 1
        if (cb > 100000) throw Error("Что то пошло не так! CB")


        if (!(typeof parent === "object")) {
            if (isResource) {
                //TODO handle error
                let filename = calcResource(path, parent)
                checkFile(filename)

            }
            if (isUrl) {
                /*
                axios(parentg).catch((error) => {
                    console.log(error)
                        if (errorCallBack !== undefined)
                            errorCallBack(Error("Invalid url:" + parent))
                    }
                )
                //TODO local only and on CICD
                //axios(process.env.PUBLIC_URL + "/cfg/" + path + "/" + parent)
                console.log(parent)
                 */
            }
            return
        } else {
            if (isResource) {
                if (parent["ru"] !== undefined) {
                    let filename = calcResource(path, parent["ru"])
                    checkFile(filename)
                }
                if (parent["et"] !== undefined) {
                    let filename = calcResource(path, parent["et"])
                    checkFile(filename)
                }
                if (parent["en"] !== undefined) {
                    let filename = calcResource(path, parent["en"])
                    checkFile(filename)
                }
            }
        }

        function checkFile(filename) {
            axios(filename).catch((error) => {
                    if (errorCallBack !== undefined)
                        errorCallBack(Error("Bad file:" + filename + " " + error))
                }
            )
        }

        Object.keys(parent).forEach((nodeKey) => {
            let isRes = nodeKey.includes("Resource")
            let isUrl = nodeKey.includes("Url")
            if (nodeKey === "path") {
                path = parent[nodeKey]
            }
            let nextNode = parent[nodeKey]
            if (nextNode !== undefined && nextNode !== null) {
                scanNode(cb, nextNode, isRes, path, isUrl)
            }
        })
    }


}

//-----Validation helpers
function validateList(parent, list, mandatoryFields, f) {
    Object.keys(parent[list]).forEach((key) => {
        let obj = parent[list][key]
        if (obj === null)
            throw Error("Empty obj:" + list + "->" + key)
        for (let k in mandatoryFields) {
            if (getImpl(obj, [mandatoryFields[k]]) === undefined)
                throw Error("Empty filed: " + mandatoryFields[k] + " for " + list + "->" + key)
        }
        if (f !== undefined)
            f(key, obj)
    })
}

function validateFkAndAssign(parent, listName, objKey, obj, field) {
    validateFk(parent, listName, objKey, obj, field)
    obj[field] = parent[listName][obj[field]]
}

function validateFk(parent, listName, objKey, obj, field) {
    if (obj[field] === undefined)
        throw Error("Mandatory FK: " + objKey + "." + field)
    if (parent[listName][obj[field]] === undefined)
        throw Error("Invalid value: " + objKey + "." + field + "=" + obj[field] + "( " + listName + ")")

}


function assertKeyNotEmpty(...keys) {
    let value = getFromSetup(...keys)
    if (value === undefined || value === null)
        throw Error("Key does not exist:" + keys)
    if (Object.keys(value).length < 1)
        throw Error("Should not be empty:" + keys)
}

function assertKeyEqual(expected, ...keys) {
    let value = getFromSetup(keys);
    if (value !== expected)
        throw Error("Expected :" + expected + ", but was: " + value + " for key:" + keys)
}

//-----Getters
export function getFromSetup(...keys) {
    return getImpl(lgSetup, keys)
}

export function getImpl(parent, keys) {
    let arr
    if (keys.length > 1)
        arr = keys
    else if (Array.isArray(keys[0]))
        arr = keys[0]
    else
        arr = [keys[0]]
    let ret = parent
    for (let k in arr) {
        let key = arr[k].split("#")[0]
        let c = arr[k].split("#")[1]
        ret = ret[key]
        if (ret !== undefined && ret !== null && ret["skin1"] !== undefined) {
            ret = resolveSkin(ret, key, c, keys)
        }
        if (ret !== undefined && ret !== null && ret["ru"] !== undefined) {
            ret = resolveLang(ret, key, c, keys)
        }

    }
    return ret

    function resolveLang(ret, key, c, keys) {
        if (c !== undefined && ret[currentLang + "#" + c] !== null)
            return ret[currentLang + "#" + c]
        if (ret[currentLang] !== undefined)
            return ret[currentLang]
        else
            return "###:" + ret["ru"]
        //throw Error("Unresolved translation: " + key + " : for " + keys + " c:" + c + " ret:" + JSON.stringify(ret))

    }

    function resolveSkin(ret, key, c, keys) {
        if (ret[currentSkin] !== undefined)
            return ret[currentSkin]
        else
            throw Error("Unresolved skin: " + key + " : for " + keys)

    }

}


function setCurrentLang(lang) {
    if (lgSetup.langs[lang] === undefined)
        throw Error("Unsupported language:" + lang)
    currentLang = lang
}

export function setCurrentLangExt(lang) {
    currentLang = lang
}


function setCurrentSkin(skin) {
    if (lgSetup.skins[skin] === undefined)
        throw Error("Unsupported skin:" + skin)
    currentSkin = skin
}

export function validateInSetup(listName, key) {
    if (key === undefined || key === null)
        throw Error("Empty " + listName)
    if (lgSetup[listName][key] === undefined)
        throw Error("Unknown " + listName + ":" + key + " (Valid values are:" + getValidKeys(listName) + ")")
    return key

}

function getValidKeys(listKey) {
    let ret = ""
    Object.keys(lgSetup[listKey]).forEach((key) => {
        ret = ret + "," + key
    })
    return ret
}


export async function testConfigLambda() {
    /*
    let currLng = currentLang
    let event = {
        "body": '{"action":"getConfig","trace":false, "productCode":"TEST_CONCERT-2030_01_01_MUSTPEAD-SHARED-DISCOUNT","lng":"ru"}'
    }
    await handler(event).then((resp) => {
            if (resp.statusCode !== 200)
                throw Error("Invalid status code")
            let product = JSON.parse(resp.body)
            //console.log(product)
            if (product.productCode !== "TEST_CONCERT-2030_01_01_MUSTPEAD-SHARED-DISCOUNT") {
                throw Error("Invalid product code!")
            }
            if (product.name !== "Тестовый концерт") {
                throw Error("Invalid product name!" + product.name + " " + product.productCode)
            }
            if (product.place.nameResolved !== "Дом Черноголовых") {
                throw Error("Invalid place!" + product.place.nameResolved)
            }
        console.log("KKK")
            console.log(product["specialProposal"])
        }
    )
    event = {
        "body": '{"action":"getConfig","trace":false, "productCode":"TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-1","lng":"ru"}'
    }
    await handler(event).then((resp) => {
            if (resp.statusCode !== 200)
                throw Error("Invalid status code")
            let product = JSON.parse(resp.body)
            //console.log(product)
            if (product.productCode !== "TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-1") {
                throw Error("Invalid product code!")
            }
            if (product.name !== "Концерт для тестирования") {
                throw Error("Invalid product name!" + product.name)
            }
            if (product.place.nameResolved !== "Дом Черноголовых") {
                throw Error("Invalid place!" + product.place.nameResolved)
            }
        }
    )
    event = {
        "body": '{"action":"getConfig","trace":false, "productCode":"TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-1","lng":"et"}'
    }
    await handler(event).then((resp) => {
            if (resp.statusCode !== 200)
                throw Error("Invalid status code")
            let product = JSON.parse(resp.body)
            //console.log(product)
            if (product.productCode !== "TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-1") {
                throw Error("Invalid product code!")
            }
            if (product.name !== "Kontsert testimiseks") {
                throw Error("Invalid product name!" + product.name)
            }
            if (product.place.nameResolved !== "Mustpeade Maja") {
                throw Error("Invalid place!" + product.place.nameResolved)
            }
        }
    )

    event = {
        "body": '{"action":"getConfig","trace":false, "productCode":"TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-2","lng":"et"}'
    }
    await handler(event).then((resp) => {
            if (resp.statusCode !== 200)
                throw Error("Invalid status code")
            let product = JSON.parse(resp.body)
            //console.log(product)
            if (product.productCode !== "TEST_CONCERT-2030_01_01_MUSTPEAD-FIXED-PRICE-2") {
                throw Error("Invalid product code!")
            }
            //TODO И это правильно, здесь нет перевода на английский
            if (product.name !== "Тестовый концерт") {
                throw Error("Invalid product name!" + product.name)
            }
            if (product.place.nameResolved !== "Mustpeade Maja") {
                throw Error("Invalid place!" + product.place.nameResolved)
            }

        }
    )
    event = {
        "body": '{"action":"getConfig","trace":false, "productCode":"LRRH-LG-LEAD","lng":"ru"}'
    }
    await handler(event).then((resp) => {
            if (resp.statusCode !== 200)
                throw Error("Invalid status code")
            let product = JSON.parse(resp.body)
            //console.log(product)
            if (product.productCode !== "LRRH-LG-LEAD") {
                throw Error("Invalid product code!")
            }
            //TODO И это правильно, здесь нет перевода на английский
            if (product.name !== "Lead Generation") {
                throw Error("Invalid product name!" + product.name)
            }
            if (product.place.nameResolved !== "ANY") {
                throw Error("Invalid place!" + product.place.nameResolved)
            }
        if (product.recordingUrl !== "https://duoclassico.eu/lrrh/gift") {
            throw Error("Invalid url!" + product.recordingUrl)
        }

        }
    )
    setCurrentLang(currLng)
     */
}

let trace = false
let useMock = false
export const handler = async (event) => {
    if (event.httpMethod === "OPTIONS") {
        console.log("OPTIONS detected! 111")
        const response = {
            statusCode: 200,
            body: JSON.stringify('Hello')
        };
        return response;
    }
    let b = JSON.parse(event.body)
    trace = b.trace
    useMock = b.mock
    if (trace) {
        console.log("Input")
        console.log(JSON.stringify(event))
    }
    let retBody = ""
    try {
        await handleRequest(event, b).then((data) => {
            retBody = data
        })
    } catch (error) {
        const response = {
            statusCode: 200,
            body: JSON.stringify('Errror' + error.message + error.stack),
        };
        return response;
    }
    const response = {
        statusCode: 200,
        body: JSON.stringify(retBody),
    };
    return response;
};


async function handleRequest(event, b) {
    try {
        if ("getConfig" === b.action) {

            return processReq(event, b)
        } else {
            console.log("Invalid action " + b.action)
            throw Error("Invalid action :" + b.action)
        }
    } catch (error) {
        datadogLogs.logger.error("Lambda:" + error.message, {error})
    }
}

function processReq(event, b) {
    currentLang = b.lng
    let start = new Date().valueOf()
    return loadLgAndCmpSetup().then(() => {
        const date = new Date();
        const options = {hour: 'short'}
        console.log("Load...OK " + (date.valueOf() - start) + " ms. " + date.toLocaleTimeString(options))

        return lgSetup.products[b.productCode]
    }).catch((error) => {
        console.log(error)
    })
}
